import React from 'react'
import { useCache } from '../utilities/useCache';
import { useDispatch } from 'react-redux';
import SignaturePad from './SignaturePad'
import lineToBr from './lineToBr'
import { helper } from '../utilities/helper';
import { apiCallBegan } from '../store/api';
import { refreshURL } from '../store/slices/cache'
const B2BAgreement = ({potential}) => {
    let  agreementArr = useCache(`/business/agreement/${potential?._id}`)
    let dispatch = useDispatch()
    let letters = ['A', 'B', 'C', 'D', 'E', 'F', 'G']

    let agreement = <>
    <h3 className='title'> PREFERRED VENDOR AGREEMENT</h3>
 {agreementArr?.map((t,i) => <>
 {t[0] ? <strong className='subTitle'>{i}. {t[0]}</strong> : null}
 {Array.isArray(t[1]) ? 
    t[1].map((st, y) =>  Array.isArray(st) ? 

            <p key={y}> <strong className='subsub'>{st[0]}. -</strong>{lineToBr(st[1])}</p>
        
            : 

       
            <p key={y} >  <strong className='subsub'>{letters[y]}. -</strong> {lineToBr(st)}</p>
      
        
    )
 :
 <p>{lineToBr(t[1])}</p>
 }

 </>)}</>

let printAgreement = (key, without) => {              
    let string = ''

  agreementArr?.forEach((t,i) => {
      string +=`${t[0] ? `<strong>${i}. ${t[0]}</strong>`:''}   
      ${Array.isArray(t[1]) ?
        t[1].map((st, y) =>  Array.isArray(st) ? 

        `<p> <strong'>${st[0]}. -</strong>${st[1]}</p>`
    
        : 

   
        `<p>  <strong >${letters[y]}. -</strong> ${st}</p>`
  
    
).join("")
         :
          `<p>${t[1]}</p>`}`})
    string += `
    
    PREFERRED VENDOR

    <img style='width: 400px; height: 200px; margin: 2rem;' src=${helper.findImage('myImage-1671545633782.jpg')} /><br/>
    <span>By: Pedro Lara on behalf of Miami Sound Rental</span><br/>
    <span>DATE: ${new Date().toDateString()}</span><br/>

    VENUE OPERATOR

    <img style='width: 400px; height: 200px; margin: 2rem;' src=${helper.findImage(key?.picture || key)} /><br/>
    <span>By: ${without ? '<br/>' :helper.fullName(potential?.main_contact)} on behalf of ${potential?.company_name || potential?.name}</span><br/>
    <span>DATE:  ${without ? '                           ' :new Date().toDateString()}</span><br/><br/>
    `
 
    dispatch(apiCallBegan({url: `/business/b2b-agreement/${potential._id}${without ? `?without=true` : ''}`,onSuccessAlert: 'Agreement Signed Successfully', method: 'POST', data: {html:`<main style='padding: 1rem;'>
    <h3 className='title' style='width: 100%; text-align: center; font-size: 2rem; margin-bottom: 2rem;'>PREFERRED VENDOR AGREEMENT</h3>
   ${string.replace(/\n/g, '<br/ >')}
</main>`}, onExtFunc: () => {
    dispatch(refreshURL(`/business/withContacts/${potential?._id}`))
}}))


}

if(potential?.status !== 'engaged') return <div className="signCont">
    <span>Your application is under review. You will be notified upon approval.</span>
</div>

return <SignaturePad wo className='signAgreement' id={potential?._id} type={'b2b'} onSave={printAgreement}>
{agreement}
</SignaturePad>

}

export default B2BAgreement